import Cookies from 'js-cookie'
import { fmUserLogin, getVerificationCode, fmUserChangeUserPwd, systemNotice, loginForceUpdatePwd, getSmsVerificationCode } from '@/view/api/ajax'
import { Message } from 'element-ui'
import SideMenuUtils from '@/utils/sideMenuUtils'
import MenuUtils from '@/utils/menuUtils'

/* ----------------------------------------*/
const sideMenus = []
const routers = []
const fmMenus = []
//
function loginData(data) {
  window.sessionStorage.setItem('menus_new', JSON.stringify(data))
  MenuUtils(routers, data)
  window.sessionStorage.setItem('sideMenus_new', JSON.stringify(sideMenus))
}
//
function filterAsyncRouter(routes) {
  let firstPage = {
    menuId: 1,
    parentId: -1,
    menuNameNick: 'page/Index/Index',
    menuName: '我的工作台',
    hasChild: 'N',
    menuDepth: 2,
    childMenus: []
  };
  const sysMenus = []
  // sysMenus.push(firstPage);
  if (routes.menus && routes.menus.childMenus !== null) {
    routes.menus.childMenus.forEach(v => {
      sysMenus.push(v)
    })
  }
  const menu = {
    path: '/',
    menuNameNick: 'layout/Home',
    menuName: 'OTS',
    hasChild: 'Y',
    isRoot: true
  }
  menu.childMenus = []
  for (let i = 0; i < sysMenus.length; i++) {
    if (sysMenus[i].menuDepth === 2) {
      menu.childMenus.push(sysMenus[i])
    }
  }
  SideMenuUtils(sideMenus, menu.childMenus)
  fmMenus.push(menu)
  loginData(fmMenus)
}
/* ----------------------------------------*/
const login = {
  namespaced: true,
  state: {
    addRouters: [],
    clients: [],
    checkedData: null,
    resp: null,
    user: JSON.parse(localStorage.getItem('user_new') || '{}'),
    systemNotice: null,
    loginForceUpdatePwdData: null,
    loginFlag: null,
    getSmsVerificationCodeData: {}
  },
  mutations: {
    FM_USER_LOGIN_REQUEST(state, data) {
      state.addRouters = routers
      state.user = data.user
      state.clients = data.clients
      state.loginFlag = data.passwordUpdateLimitFlag //密码修改标识：10--首次登录  20--超过90天未修改密码
      localStorage.setItem('user_new', JSON.stringify(data.user));
      sessionStorage.setItem('clients_new', JSON.stringify(data.clients))
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    FM_USER_CHANGE_USER_PWD_REQUEST: (state, obj) => {
      state.checkedData = obj
    },
    RESP(state, data){
      state.resp = data
    },
    SYSTEM_NOTICE_DATA(state, data){
      state.systemNotice = data.obj || []
    },
    CONFIRM_PWD_DATA(state, data){
      state.loginForceUpdatePwdData = data
    },
    SMS_VERIFICATION_DATA(state, data){
      state.getSmsVerificationCodeData = data
    }
  },
  actions: {
    // 登录请求
    async fmUserLoginRequest({ dispatch, commit }, data) {
      let res = await fmUserLogin(data)
      if (res.code === 200){
        const {code, obj} = res;
        const {refreshToken,token} = obj;
        localStorage.setItem("token_new", token);
        localStorage.setItem("refresh_new", refreshToken);
        localStorage.setItem("pwdLoginUser_new", obj.user.remark);
        filterAsyncRouter(obj)
        commit('FM_USER_LOGIN_REQUEST',obj)
        //dispatch('kdOrganization/findAll',{},{root:true});
        //dispatch('kdSortingPlan/findAll',{},{root:true});
      }
    },

    async getVerificationCodeRequest({ dispatch, commit }, data) {
      let res = await getVerificationCode(data);

      commit('RESP', res);

    },
    //
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    async fmUserChangeUserPwdRequest({ commit }, obj) {
      const resp = await fmUserChangeUserPwd(obj)
      commit('FM_USER_CHANGE_USER_PWD_REQUEST', resp)
    },
    async getSystemNotice({ commit }, data){
      let resp = await systemNotice(data);
      commit('SYSTEM_NOTICE_DATA', resp)
    },
    async loginForceUpdatePwd({ commit }, data){
      let resp = await loginForceUpdatePwd(data);
      commit('CONFIRM_PWD_DATA', resp)
    },
    async getSmsVerificationCode({ commit }, data){
      let resp = await getSmsVerificationCode(data);
      commit('SMS_VERIFICATION_DATA', resp)
    },
  }
}
export default login



// WEBPACK FOOTER //
// ./src/store/modules/login.js